import { Component } from 'react'
import { OperationStart } from 'stylewhere/components'
import { EncodingExtensions } from 'stylewhere/extensions'

export default class TransferToZoneStart extends Component {
  render() {
    return <OperationStart submitPath="/encoding/imbustatrice/:opCode/encode" extensions={EncodingExtensions} />
  }
}
